// EngageRenderer.ts
import { ActionProcessor } from "./ActionProcessor";
import { eventsService, AppEvents } from "@Engage.Core";
export class EngageRenderer {
    static render(response) {
        var _a;
        if (!(response === null || response === void 0 ? void 0 : response.showAction) || !((_a = response === null || response === void 0 ? void 0 : response.actions) === null || _a === void 0 ? void 0 : _a.length)) {
            eventsService.dispatch(AppEvents.ActionNotFound, response);
            return;
        }
        response.actions.forEach((action) => {
            ActionProcessor.process(action);
        });
    }
}
